function InvitationService(ApiService) {
  'ngInject'

  const service = {};
  service.setPassword = function (token, password_form, callbackFunc ) {
    let data = {
      invitation_token: token,
      password: password_form.password,
      password_confirmation: password_form.confirm_password
    };
    ApiService.put(`/auth/invitation`, data, callbackFunc);
  };
  return service;
}

export default {
  name: 'InvitationService',
  fn: InvitationService
}
